export const mediaMaxBytesForAiGrading = 2_000_000_000; // 2 gb
export const imageMaxBytesForAiGrading = 5_000_000; // 5 mb
export const mediaMaxBytesForAiPeerReview = 20_000_000; // 20 mb
export const mediaMaxSecondsForAiGrading = 900; // 15 minutes

// If an entry is listed here, it does not necessarily mean that it is not allowed for submission,
// it just means that it is not supported for AI grading.
// (The listed file types are supported for AI grading.)

// For these key-value pairs, the keys represent the actual file extensions (without the dot),
// and the values represent a support text / "label" like ".gif (non-animated)"

export const addDotsToExtensionsKeys = (extensionsMap: Record<string, string>): string[] =>
  Object.keys(extensionsMap).map((extension) => `.${extension}`);

export const aiGradingFileTypesText = {
  txt: '.txt',
  text: '.text',
  csv: '.csv',
};

export const aiGradingFileTypesTextPeerReview = {
  ...aiGradingFileTypesText,
  doc: '.doc',
  docx: '.docx',
  pdf: '.pdf',
};

export const aiGradingFileTypesImage = {
  png: '.png',
  jpg: '.jpg',
  jpeg: '.jpeg',
  jfif: '.jfif',
  webp: '.webp',
  // https://coursera.atlassian.net/browse/GRADE-6565: gif is not supported for AI-graded questions
  // gif: 'gif (non-animated)',
  bmp: '.bmp',
  tiff: '.tiff',
  tif: '.tif',
};

export const aiGradingFileTypesCoding = {
  bash: '.bash',
  bat: '.bat',
  c: '.c',
  cpp: '.cpp',
  css: '.css',
  go: '.go',
  htm: '.htm',
  html: '.html',
  java: '.java',
  json: '.json',
  jsp: '.jsp',
  jsx: '.jsx',
  md: '.md',
  php: '.php',
  py: '.py',
  r: '.r',
  scss: '.scss',
  sh: '.sh',
  sml: '.sml',
  sql: '.sql',
  swift: '.swift',
  ts: '.ts',
  tsx: '.tsx',
  xml: '.xml',
  yml: '.yml',
  js: '.js',
};

export const aiGradingFileTypesAudio = {
  mp3: '.mp3',
  wav: '.wav',
  aac: '.aac',
  flac: '.flac',
};

// wmv is not supported in HTML5 for OEQs/SGAs
// https://github.com/webedx-spark/web/pull/48979/files#r2004197990
export const aiGradingFileTypesVideoOeq = {
  mp4: '.mp4',
  mov: '.mov',
  webm: '.webm',
};

// wmv is supported for AI grading videos in Peer Review
export const aiGradingFileTypesVideoPeerReview = {
  ...aiGradingFileTypesVideoOeq,
  wmv: '.wmv',
};

export const aiGradingFileTypesPresentation = {
  ppt: '.ppt',
  pptx: '.pptx',
};

// value is the label for the file type in key
export const allowedFileTypesForPeerReviewAiGrading = {
  ...aiGradingFileTypesTextPeerReview,
  ...aiGradingFileTypesVideoPeerReview,
  ...aiGradingFileTypesImage,
  ...aiGradingFileTypesCoding,
  ...aiGradingFileTypesAudio,
  ...aiGradingFileTypesPresentation,
} as const;

/**
 * The feature was enabled for 3 courses many years ago. Currently there are no plans to enable it for more partners.
 * Hardcoding the values so we can clean up the EPIC.
 * TODO: Evaluate if we want to remove the feature.
 */
export const getEnablePrePenaltyGrades = (courseId: string) => {
  return ['ATH-zIL6EeqDmApTEuqcmQ', 'KSN6xO5PEeuGPhLqrICWCw', 'tGYgpiA1EeyP7gojjJdnpw'].includes(courseId);
};

export const isFeedbackMomentSupported = (fileExtension: string) => {
  return (
    Object.keys(aiGradingFileTypesVideoOeq).includes(fileExtension) ||
    Object.keys(aiGradingFileTypesAudio).includes(fileExtension)
  );
};
